import React from "react";

const Main = class extends React.Component {
    render() {
        return <div></div>;
    }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/Main.jsx